import { Component, Input, OnInit, Output } from "@angular/core";
import { Subject } from "rxjs";
import { BasicActionsEventType } from "./basic-actions-event-type";

@Component({
  selector: "app-basic-actions",
  templateUrl: "./basic-actions.component.html",
})
export class BasicActionsComponent implements OnInit {
  constructor() {}

  @Output()
  emitter = new Subject<BasicActionsEventType>();

  @Input()
  data = {};

  ngOnInit(): void {}

  onAction1(event) {
    event.stopPropagation()
    this.emitter.next({
      cmd: "edit",
      data: this.data,
    });
  }
  onAction2(event) {
    event.stopPropagation()
    this.emitter.next({
      cmd: "delete",
      data: this.data,
    });
  }

  ngOnDestroy() {
    this.emitter.unsubscribe();
  }
}